import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";

import { PrivacyPolicyContent, TermsOfServiceContent } from "../legal";

export type LegalType = "terms" | "privacy" | "subscription";

interface LegalDrawerProps {
  type: LegalType | null;
  onClose: () => void;
}

const getTitle = (type: LegalType) => {
  switch (type) {
    case "terms":
      return "termsTitle";
    case "privacy":
      return "privacyTitle";
    case "subscription":
      return "subscriptionTitle";
  }
};

export const LegalDrawer = ({ type, onClose }: LegalDrawerProps) => {
  const { t } = useTranslation("Common", { keyPrefix: "LegalDrawer" });

  const title = getTitle(type || "terms");

  return (
    <Drawer open={!!type} onOpenChange={(open) => !open && onClose()}>
      <DrawerContent className="max-h-[90vh]">
        <DrawerHeader className="flex flex-row items-center justify-end">
          <DrawerTitle className="sr-only">{title}</DrawerTitle>
          <DrawerClose asChild>
            <Button variant="ghost" size="icon">
              <X className="h-4 w-4" />
              <span className="sr-only">{t("close")}</span>
            </Button>
          </DrawerClose>
        </DrawerHeader>
        <div className="overflow-y-auto">
          {type === "terms" && <TermsOfServiceContent />}
          {type === "privacy" && <PrivacyPolicyContent />}
        </div>
      </DrawerContent>
    </Drawer>
  );
};
